import React from 'react';

const EnvelopeIcon = () => {
	return (
		<svg
			fill='none'
			height='16'
			viewBox='0 0 16 16'
			width='16'
		>
			<g
				clipPath='url(#clip0_28627_7552)'
			>
				<path
					d='M14 3.5L8 9L2 3.5'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M2 3.5H14V12C14 12.1326 13.9473 12.2598 13.8536 12.3536C13.7598 12.4473 13.6326 12.5 13.5 12.5H2.5C2.36739 12.5 2.24021 12.4473 2.14645 12.3536C2.05268 12.2598 2 12.1326 2 12V3.5Z'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M6.90625 8L2.15625 12.3562'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M13.8438 12.3562L9.09375 8'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath
					id='clip0_28627_7552'
				>
					<rect
						fill='white'
						height='16'
						width='16'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default EnvelopeIcon;
